export enum ERoles {
    CompanyAdmin = 'role:ridango:company-admin',
    DeviceManager = 'role:ridango:device-manager',
    Superuser = 'role:ridango:admin',
    Technician = 'role:ridango:technician',
    PaymentsSupportPan = 'role:ridango:payments-support-pan',
    PaymentsSupport = 'role:ridango:payments-support'
}
